// // src/components/About.js
// import React from "react";

// const About = ({ language }) => {
//   const aboutData = {
//     mission: {
//       title: { en: "Our Mission", ar: "رسالة الأكاديمية" },
//       content: {
//         en: "Inspiring workers, summoning and developing their capabilities, and motivating them to think and innovate through our programs in the fields of behavior, knowledge and skills.",
//         ar: "إستنهاض همم العاملين وإستدعاء قدراتهم وتنميتها، وتحفيزهم على التفكير والابداع، من خلال برامجها في مجالات السلوك والمعرفة والمهارات.",
//       },
//     },
//     vision: {
//       title: { en: "Our Vision", ar: "رؤية الأكاديمية" },
//       content: {
//         en: '"Excellence".... Through establishing the idea of dual training - theoretical/practical - and adopting workshops as a means of transferring knowledge without traditional theoretical lectures.',
//         ar: '"التمييز" .... من خلال ترسيخ فكرة التدريب المزدوج - نظري/عملي - واعتماد ورش العمل كوسيلة لنقل المعرفة دون المحاضرات النظرية التقليدية.',
//       },
//     },
//     goals: {
//       title: { en: "Our Goals", ar: "أهداف الأكاديمية" },
//       items: [
//         {
//           en: "Preparing and qualifying new employees to integrate them into the work environment through the orientation and preparation program for assuming work.",
//           ar: "تهيئة وإعداد العاملين الجدد لغرض دمجهم في بيئة العمل من خلال برنامج التهيأة والإعداد لاستلام العمل.",
//         },
//         {
//           en: "Raising skills and developing the capabilities of employees to improve their performance level through continuous training programs.",
//           ar: "رفع مهارات وتطوير قدرات العاملين للإرتقاء بمستوى أدائهم من خلال برامج التدريب المستمر.",
//         },
//         {
//           en: "Building human cadres to be assigned to work in various locations in the group companies through specialized preparation programs.",
//           ar: "بناء كوادر بشرية لإلحاقها بالعمل في المواقع المختلفة في شركات المجموعة من خلال برامج الإعداد المتخصصة.",
//         },
//         {
//           en: "Preparing employees nominated for promotion to higher job categories with good preparation that aligns with the requirements of those categories.",
//           ar: "إعداد العاملين المرشحين للترقية الى الفئات الوظيفية الأعلى إعداداً جيداً ينسجم مع متطلبات تلك الفئات.",
//         },
//       ],
//     },
//     history: {
//       title: {
//         en: "Brief About Arma Academy",
//         ar: "نبذة مختصرة عن أكاديمية آرما",
//       },
//       subtitle: {
//         en: "The Idea - Establishment - Inception",
//         ar: "الفكرة – التأسيس – النشأة",
//       },
//       content: {
//         en: "In 1986-1987, the Technical and Administrative Training Center of HSA Group of Companies was established in Taiz, Yemen. The center worked during the period until 1987-1993 on implementing programs to prepare mechanical maintenance technicians and electrical maintenance technicians through theoretical and practical training.",
//         ar: "في عام 1986-1987 تأسس مركز التدريب الفني والإداري التابع لمجموعة شركات هائل سعيد أنعم HSA في مدينة تعز باليمن. عمل المركز خلال الفترة حتى 1987-1993 على: تنفيذ برامج إعداد فني صيانة ميكانيكية – حيث يتم تدريب خريجي الدراسة الإعدادية لمدة 24 شهراً – تدريب نظري وعملي. إعداد فني صيانة كهربائية – حيث يتم تدريب خريجي الدراسة الثانوية لمدة 18 شهراً – تدريب نظري وعملي.",
//       },
//     },
//   };

//   return (
//     <section id="about" className="py-16 bg-white">
//       <div className="container mx-auto px-4">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4">
//             {language === "ar" ? "حول الاكاديمية" : "About the Academy"}
//           </h2>
//           <div className="w-24 h-1 bg-green-600 mx-auto"></div>
//         </div>

//         {/* Mission & Vision */}
//         <div className="grid md:grid-cols-2 gap-8 mb-12">
//           <div className="bg-green-50 p-8 rounded-2xl border-l-4 border-green-600 transform hover:-translate-y-1 transition-all duration-300">
//             <div className="flex items-center mb-4">
//               <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 rtl:mr-0 rtl:ml-4">
//                 <svg
//                   className="w-6 h-6 text-green-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//                   />
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold text-green-900">
//                 {aboutData.vision.title[language]}
//               </h3>
//             </div>
//             <p className="text-gray-700 leading-relaxed">
//               {aboutData.vision.content[language]}
//             </p>
//           </div>
          
//           <div className="bg-green-50 p-8 rounded-2xl border-l-4 border-green-600 transform hover:-translate-y-1 transition-all duration-300">
//             <div className="flex items-center mb-4">
//               <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 rtl:mr-0 rtl:ml-4">
//                 <svg
//                   className="w-6 h-6 text-green-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M13 10V3L4 14h7v7l9-11h-7z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold text-green-900">
//                 {aboutData.mission.title[language]}
//               </h3>
//             </div>
//             <p className="text-gray-700 leading-relaxed">
//               {aboutData.mission.content[language]}
//             </p>
//           </div>
//         </div>

//         {/* Goals */}
//         <div className="mb-12">
//           <h3 className="text-2xl font-bold text-green-900 mb-6 text-center">
//             {aboutData.goals.title[language]}
//           </h3>
//           <div className="grid md:grid-cols-2 gap-6">
//             {aboutData.goals.items.map((goal, index) => (
//               <div
//                 key={index}
//                 className="flex items-start p-4 bg-white rounded-lg shadow-sm border border-green-100 hover:shadow-md transition-shadow"
//               >
//                 <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-800 rounded-full flex items-center justify-center font-bold mr-4 rtl:mr-0 rtl:ml-4 mt-1">
//                   {index + 1}
//                 </div>
//                 <p className="text-gray-700">{goal[language]}</p>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* History */}
//         <div className="bg-gradient-to-r from-green-800 to-green-900 text-white p-8 rounded-2xl">
//           <h3 className="text-2xl font-bold mb-2">
//             {aboutData.history.title[language]}
//           </h3>
//           <p className="text-green-200 mb-4 font-medium">
//             {aboutData.history.subtitle[language]}
//           </p>
//           <p className="leading-relaxed">
//             {aboutData.history.content[language]}
//           </p>

//           {/* Timeline for additional history */}
//           <div className="mt-8 grid md:grid-cols-3 gap-6">
//             {[
//               {
//                 year: "1994-1995",
//                 desc: {
//                   en: "Implementation of 76 training programs in various fields",
//                   ar: "تنفيذ 76 برنامجاً تدريبياً في كافة المجالات",
//                 },
//               },
//               {
//                 year: "1995-1996",
//                 desc: {
//                   en: "Transition to 'Technical Operator Preparation' program",
//                   ar: "التحول إلى برنامج 'إعداد المشغل الفني'",
//                 },
//               },
//               {
//                 year: "1998",
//                 desc: {
//                   en: "Proposal to transform into 'Al-Saeed Academy'",
//                   ar: "مقترح تحويل المركز إلى 'أكاديمية السعيد'",
//                 },
//               },
//             ].map((item, index) => (
//               <div key={index} className="text-center">
//                 <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-3 font-bold">
//                   {item.year}
//                 </div>
//                 <p className="text-green-200 text-sm">{item.desc[language]}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default About;

// src/components/About.js
// import React from "react";

// const About = ({ language }) => {
//   const aboutData = {
//     mission: {
//       title: { en: "Our Mission", ar: "رسالة الأكاديمية" },
//       content: {
//         en: "Inspiring workers, summoning and developing their capabilities, and motivating them to think and innovate through our programs in the fields of behavior, knowledge and skills.",
//         ar: "إستنهاض همم العاملين وإستدعاء قدراتهم وتنميتها، وتحفيزهم على التفكير والابداع، من خلال برامجها في مجالات السلوك والمعرفة والمهارات.",
//       },
//     },
//     vision: {
//       title: { en: "Our Vision", ar: "رؤية الأكاديمية" },
//       content: {
//         en: '"Excellence".... Through establishing the idea of dual training - theoretical/practical - and adopting workshops as a means of transferring knowledge without traditional theoretical lectures.',
//         ar: '"التمييز" .... من خلال ترسيخ فكرة التدريب المزدوج - نظري/عملي - واعتماد ورش العمل كوسيلة لنقل المعرفة دون المحاضرات النظرية التقليدية.',
//       },
//     },
//     goals: {
//       title: { en: "Our Goals", ar: "أهداف الأكاديمية" },
//       items: [
//         {
//           en: "Preparing and qualifying new employees to integrate them into the work environment through the orientation and preparation program for assuming work.",
//           ar: "تهيئة وإعداد العاملين الجدد لغرض دمجهم في بيئة العمل من خلال برنامج التهيأة والإعداد لاستلام العمل.",
//         },
//         {
//           en: "Raising skills and developing the capabilities of employees to improve their performance level through continuous training programs.",
//           ar: "رفع مهارات وتطوير قدرات العاملين للإرتقاء بمستوى أدائهم من خلال برامج التدريب المستمر.",
//         },
//         {
//           en: "Building human cadres to be assigned to work in various locations in the group companies through specialized preparation programs.",
//           ar: "بناء كوادر بشرية لإلحاقها بالعمل في المواقع المختلفة في شركات المجموعة من خلال برامج الإعداد المتخصصة.",
//         },
//         {
//           en: "Preparing employees nominated for promotion to higher job categories with good preparation that aligns with the requirements of those categories.",
//           ar: "إعداد العاملين المرشحين للترقية الى الفئات الوظيفية الأعلى إعداداً جيداً ينسجم مع متطلبات تلك الفئات.",
//         },
//       ],
//     },
//     history: {
//       title: {
//         en: "Brief About Arma Academy",
//         ar: "نبذة مختصرة عن أكاديمية آرما",
//       },
//       subtitle: {
//         en: "The Idea - Establishment - Development",
//         ar: "الفكرة – التأسيس – التطور",
//       },
//       timeline: [
//         {
//           year: "1986-1987",
//           title: {
//             en: "Establishment of Technical and Administrative Training Center",
//             ar: "تأسيس مركز التدريب الفني والإداري",
//           },
//           content: {
//             en: "The Technical and Administrative Training Center of HSA Group of Companies was established in Taiz, Yemen.",
//             ar: "تأسس مركز التدريب الفني والإداري التابع لمجموعة شركات هائل سعيد أنعم HSA في مدينة تعز باليمن.",
//           },
//           details: {
//             en: [
//               "Implemented programs:",
//               "- Mechanical Maintenance Technician Preparation: Training intermediate school graduates for 24 months (theoretical & practical)",
//               "- Electrical Maintenance Technician Preparation: Training high school graduates for 18 months (theoretical & practical)",
//               "- Implemented 10 programs in administrative fields, including 6 English language teaching programs"
//             ],
//             ar: [
//               "عمل المركز خلال الفترة حتى 1987-1993 على:",
//               "تنفيذ برامج :",
//               "- إعداد فني صيانة ميكانيكية – حيث يتم تدريب خريجي الدراسة الإعدادية لمدة 24 شهراً – تدريب نظري وعملي.",
//               "- إعداد فني صيانة كهربائية – حيث يتم تدريب خريجي الدراسة الثانوية لمدة 18 شهراً – تدريب نظري وعملي.",
//               "- تنفيذ 10 برامج في المجالات الإدارية منها 6 برامج لتعليم اللغة الإنجليزية."
//             ]
//           }
//         },
//         {
//           year: "1995",
//           title: {
//             en: "Ambitious Training Plan Implementation",
//             ar: "تنفيذ خطة تدريب طموحة",
//           },
//           content: {
//             en: "The Human Resources Department in Yemen implemented an ambitious training plan starting from 1/1/1995.",
//             ar: "قامت إدارة الموارد البشرية في الادارة العامة للمجموعة في اليمن بوضع خطة تدريب طموحة نفذت بداية من 1/1/1995.",
//           },
//           details: {
//             en: [
//               "Executed 76 training programs in various fields, including:",
//               "- Human Resources Management programs for HR staff and general managers",
//               "- Marketing programs for marketing staff and general managers",
//               "- Finance programs for finance staff and general managers",
//               "- Programs in production management, warehouses, maintenance, sales, and other fields"
//             ],
//             ar: [
//               "تم تنفيذ 76 برنامجاً تدريبياً خلال العام 1995 في كافة المجالات، منها على سبيل المثال:",
//               "- برنامج في إدارة الموارد البشرية للعاملين في إدارات الموارد البشرية (بعد تغير مسماها من شئون العاملين) من جميع الشركات",
//               "- برنامج في إدارة الموارد البشرية مخصص لمدراء عموم الشركات ونوابهم",
//               "- برنامج في التسويق للعاملين في إدارات التسويق من جميع الشركات",
//               "- برنامج في التسويق مخصص لمدراء عموم الشركات ونوابهم",
//               "- برامج في المالية للعاملين في الإدارات المالية من جميع الشركات",
//               "- برامج في المالية مخصص لمدراء عموم الشركات ونوابهم",
//               "- وهكذا في المجالات الأخرى كإدارة الإنتاج – المخازن – الصيانة – المبيعات – وغيرها"
//             ]
//           }
//         },
//         {
//           year: "1996-1999",
//           title: {
//             en: "Technical Operator Preparation Program",
//             ar: "برنامج إعداد المشغل الفني",
//           },
//           content: {
//             en: "Changed technician programs to 'Technical Operator Preparation' program - training only high school graduates for 3 years.",
//             ar: "تم تغير برامج الفنيين (الصيانة الميكانيكية والصيانة الكهربائية) الى برنامج 'إعداد المشغل الفني'.",
//           },
//           details: {
//             en: [
//               "Started on 1/1/1996 with 100 trainees divided into two groups:",
//               "- Group 1 (50 trainees): 3 days theoretical/practical training at the center, 3 days field training in factories",
//               "- Group 2 (50 trainees): Opposite schedule to Group 1",
//               "First batch graduated end of 1998, second batch (1997-1999) also graduated successfully"
//             ],
//             ar: [
//               "يتم تدريب خريجي الثانوية العامة فقط (دون الإعدادية) ولمدة 3 سنوات.",
//               "تمت المباشرة بهذا النظام في 1/1/1996 حيث تم قبول دفعة من 100 متدرب – تم تقسيمهم على مجموعتين:",
//               "- الأولى (50 متدرب): تتواجد في مركز التدريب 3 أيام في الأسبوع للتدريب النظري والعملي في قاعات وورش ومعامل المركز، وتتواجد في الـ 3 أيام الأخرى في المصانع للتدريب العملي الميداني",
//               "- الثانية (50متدرب): تتواجد في المركز والمصانع عكس الأولى.",
//               "تخرجت الدفعة الأولى في نهاية عام 1998، والدفعة الثانية (1997-1999) تخرجت أيضاً بنجاح"
//             ]
//           }
//         },
//         {
//           year: "2006",
//           title: {
//             en: "Establishment of Arma Academy in Egypt",
//             ar: "تأسيس أكاديمية آرما في مصر",
//           },
//           content: {
//             en: "Proposal to establish Arma Academy in Egypt, starting with Technical Operator Preparation program.",
//             ar: "تقدُم إدارة الموارد البشرية في الادارة العامة لإقليم مصر بإستحداث أكاديمية آرما في مصر.",
//           },
//           details: {
//             en: [
//               "Started in Egypt with Technical Operator Preparation program",
//               "Implemented various programs during 2006-2008"
//             ],
//             ar: [
//               "البداية في تنفيذ برنامج إعداد المشغلين الفنيين",
//               "نفذت الأكاديمية خلال الفترة 2006 – 2008 برامج متنوعة"
//             ]
//           }
//         },
//         {
//           year: "2011",
//           title: {
//             en: "Transition to Al-Saeed Academy & SOM Program",
//             ar: "التحول إلى أكاديمية السعيد وبرنامج SOM",
//           },
//           content: {
//             en: "Name changed to 'Al-Saeed Academy' and launched Shift Operation Manager (SOM) preparation program.",
//             ar: "تم تغيير اسم الاكاديمية ليكون 'أكاديمية السعيد' وبدء برنامج إعداد مدير عمليات وردية.",
//           },
//           details: {
//             en: [
//               "Name changed to 'Al-Saeed Academy'",
//               "Started Shift Operation Manager (SOM) preparation program in 2011",
//               "Implemented various programs during 2011-2021"
//             ],
//             ar: [
//               "في عام 2011 تم تغيير اسم الاكاديمية ليكون 'أكاديمية السعيد'",
//               "نفذت خلال الفترة 2011 – 2021 برامج متنوعة",
//               "في العام 2011 تمت المباشرة بتنفيذ برنامج إعداد مدير عمليات وردية SOM حيث بدأت الدفعة الاولى"
//             ]
//           }
//         },
//         {
//           year: "2014",
//           title: {
//             en: "Management Trainees Program",
//             ar: "برنامج المتدربين الإداريين",
//           },
//           content: {
//             en: "Launched Management Trainees preparation program.",
//             ar: "بدء تنفيذ برنامج إعداد المتدربين الإداريين.",
//           },
//           details: {
//             en: [
//               "Started Management Trainees preparation program in 2014",
//               "Graduated two batches of trainees"
//             ],
//             ar: [
//               "في العام 2014 تمت المباشرة بتنفيذ برنامج إعداد المتدربين الاداريين",
//               "حيث تم تخريج دفعتين وفق البرنامج"
//             ]
//           }
//         },
//         {
//           year: "2020-2021",
//           title: {
//             en: "COVID-19 Pause & New Management",
//             ar: "توقف كورونا والإدارة الجديدة",
//           },
//           content: {
//             en: "Operations paused due to COVID-19 pandemic, resumed under new management of Egypt region.",
//             ar: "توقف العمل بسبب جائحة كورونا واستئناف العمل تحت الإدارة الجديدة.",
//           },
//           details: {
//             en: [
//               "Operations paused in 2020 due to COVID-19 pandemic",
//               "Work continued under new management of Egypt region general administration"
//             ],
//             ar: [
//               "في العام 2020 توقف العمل في الاكاديمية بسبب جائحة كورونا (كوفيد 2019)",
//               "إستمر التوقف حتى تسلم الإدارة العامة للمجموعة إقليم مصر وتكليف الإدارة الجديدة بإدارة الاقليم"
//             ]
//           }
//         }
//       ]
//     },
//   };

//   return (
//     <section id="about" className="py-16 bg-white">
//       <div className="container mx-auto px-4">
//         <div className="text-center mb-12">
//           <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4">
//             {language === "ar" ? "حول الاكاديمية" : "About the Academy"}
//           </h2>
//           <div className="w-24 h-1 bg-green-600 mx-auto"></div>
//         </div>

//         {/* Mission & Vision */}
//         <div className="grid md:grid-cols-2 gap-8 mb-12">
//           <div className="bg-green-50 p-8 rounded-2xl border-l-4 border-green-600 transform hover:-translate-y-1 transition-all duration-300">
//             <div className="flex items-center mb-4">
//               <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 rtl:mr-0 rtl:ml-4">
//                 <svg
//                   className="w-6 h-6 text-green-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//                   />
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold text-green-900">
//                 {aboutData.vision.title[language]}
//               </h3>
//             </div>
//             <p className="text-gray-700 leading-relaxed">
//               {aboutData.vision.content[language]}
//             </p>
//           </div>
          
//           <div className="bg-green-50 p-8 rounded-2xl border-l-4 border-green-600 transform hover:-translate-y-1 transition-all duration-300">
//             <div className="flex items-center mb-4">
//               <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 rtl:mr-0 rtl:ml-4">
//                 <svg
//                   className="w-6 h-6 text-green-600"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M13 10V3L4 14h7v7l9-11h-7z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-bold text-green-900">
//                 {aboutData.mission.title[language]}
//               </h3>
//             </div>
//             <p className="text-gray-700 leading-relaxed">
//               {aboutData.mission.content[language]}
//             </p>
//           </div>
//         </div>

//         {/* Goals */}
//         <div className="mb-12">
//           <h3 className="text-2xl font-bold text-green-900 mb-6 text-center">
//             {aboutData.goals.title[language]}
//           </h3>
//           <div className="grid md:grid-cols-2 gap-6">
//             {aboutData.goals.items.map((goal, index) => (
//               <div
//                 key={index}
//                 className="flex items-start p-4 bg-white rounded-lg shadow-sm border border-green-100 hover:shadow-md transition-shadow"
//               >
//                 <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-800 rounded-full flex items-center justify-center font-bold mr-4 rtl:mr-0 rtl:ml-4 mt-1">
//                   {index + 1}
//                 </div>
//                 <p className="text-gray-700">{goal[language]}</p>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* History Timeline */}
//         <div className="bg-gradient-to-r from-green-800 to-green-900 text-white p-8 rounded-2xl">
//           <h3 className="text-2xl font-bold mb-2">
//             {aboutData.history.title[language]}
//           </h3>
//           <p className="text-green-200 mb-6 font-medium">
//             {aboutData.history.subtitle[language]}
//           </p>

//           {/* Timeline */}
//           <div className="relative">
//             {/* Timeline line */}
//             <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-green-600 hidden md:block"></div>
            
//             {aboutData.history.timeline.map((item, index) => (
//               <div 
//                 key={index} 
//                 className={`relative mb-8 md:mb-12 ${
//                   index % 2 === 0 
//                     ? 'md:pr-1/2 md:pl-0 md:text-right md:pr-8' 
//                     : 'md:pl-1/2 md:pr-0 md:text-left md:pl-8'
//                 }`}
//               >
//                 {/* Timeline dot */}
//                 <div className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-6 h-6 bg-green-500 rounded-full border-4 border-green-900 z-10 hidden md:block"></div>
                
//                 {/* Content card */}
//                 <div className={`bg-green-700/30 backdrop-blur-sm rounded-xl p-6 border border-green-600/30 ${
//                   index % 2 === 0 ? 'md:mr-4' : 'md:ml-4'
//                 }`}>
//                   <div className="flex flex-col md:flex-row md:items-center justify-between mb-4">
//                     <div className={`w-full ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
//                       <div className="inline-block px-4 py-1 bg-green-600 rounded-full font-bold mb-2">
//                         {item.year}
//                       </div>
//                       <h4 className="text-xl font-bold mb-2">
//                         {item.title[language]}
//                       </h4>
//                       <p className="text-green-200 mb-3">
//                         {item.content[language]}
//                       </p>
//                     </div>
//                   </div>
                  
//                   {/* Details */}
//                   <div className={`bg-green-900/50 p-4 rounded-lg ${
//                     index % 2 === 0 ? 'md:text-right' : 'md:text-left'
//                   }`}>
//                     {item.details[language].map((detail, detailIndex) => (
//                       <p key={detailIndex} className="text-green-100 mb-1 text-sm">
//                         {detail}
//                       </p>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Mobile timeline alternative */}
//           <div className="md:hidden mt-8 space-y-6">
//             {aboutData.history.timeline.map((item, index) => (
//               <div key={index} className="bg-green-700/30 backdrop-blur-sm rounded-xl p-6 border border-green-600/30">
//                 <div className="inline-block px-4 py-1 bg-green-600 rounded-full font-bold mb-3">
//                   {item.year}
//                 </div>
//                 <h4 className="text-xl font-bold mb-2">
//                   {item.title[language]}
//                 </h4>
//                 <p className="text-green-200 mb-3">
//                   {item.content[language]}
//                 </p>
//                 <div className="bg-green-900/50 p-4 rounded-lg">
//                   {item.details[language].map((detail, detailIndex) => (
//                     <p key={detailIndex} className="text-green-100 mb-1 text-sm">
//                       {detail}
//                     </p>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default About;


// src/components/About.js (Updated)
import React from "react";
import { Link } from "react-router-dom";

const About = ({ language }) => {
  const aboutData = {
    mission: {
      title: { en: "Our Mission", ar: "رسالة الأكاديمية" },
      content: {
        en: "Inspiring workers, summoning and developing their capabilities, and motivating them to think and innovate through our programs in the fields of behavior, knowledge and skills.",
        ar: "إستنهاض همم العاملين وإستدعاء قدراتهم وتنميتها، وتحفيزهم على التفكير والابداع، من خلال برامجها في مجالات السلوك والمعرفة والمهارات.",
      },
    },
    vision: {
      title: { en: "Our Vision", ar: "رؤية الأكاديمية" },
      content: {
        en: '"Excellence".... Through establishing the idea of dual training - theoretical/practical - and adopting workshops as a means of transferring knowledge without traditional theoretical lectures.',
        ar: '"التمييز" .... من خلال ترسيخ فكرة التدريب المزدوج - نظري/عملي - واعتماد ورش العمل كوسيلة لنقل المعرفة دون المحاضرات النظرية التقليدية.',
      },
    },
    goals: {
      title: { en: "Our Goals", ar: "أهداف الأكاديمية" },
      items: [
        {
          en: "Preparing and qualifying new employees to integrate them into the work environment through the orientation and preparation program for assuming work.",
          ar: "تهيئة وإعداد العاملين الجدد لغرض دمجهم في بيئة العمل من خلال برنامج التهيأة والإعداد لاستلام العمل.",
        },
        {
          en: "Raising skills and developing the capabilities of employees to improve their performance level through continuous training programs.",
          ar: "رفع مهارات وتطوير قدرات العاملين للإرتقاء بمستوى أدائهم من خلال برامج التدريب المستمر.",
        },
        {
          en: "Building human cadres to be assigned to work in various locations in the group companies through specialized preparation programs.",
          ar: "بناء كوادر بشرية لإلحاقها بالعمل في المواقع المختلفة في شركات المجموعة من خلال برامج الإعداد المتخصصة.",
        },
        {
          en: "Preparing employees nominated for promotion to higher job categories with good preparation that aligns with the requirements of those categories.",
          ar: "إعداد العاملين المرشحين للترقية الى الفئات الوظيفية الأعلى إعداداً جيداً ينسجم مع متطلبات تلك الفئات.",
        },
      ],
    },
    history: {
      title: {
        en: "Brief History",
        ar: "نبذة تاريخية",
      },
      content: {
        en: "Since 1986, Arma Academy has been at the forefront of technical and administrative training. Established as the Technical and Administrative Training Center of HSA Group in Yemen, it has evolved through decades of excellence.",
        ar: "منذ عام 1986، كانت أكاديمية آرما في طليعة التدريب الفني والإداري. تأسست كمركز للتدريب الفني والإداري لمجموعة HSA في اليمن، وتطورت عبر عقود من التميز.",
      },
      highlights: [
        {
          year: "1986",
          desc: {
            en: "Founded in Yemen",
            ar: "التأسيس في اليمن",
          }
        },
        {
          year: "1995",
          desc: {
            en: "76 training programs implemented",
            ar: "تنفيذ 76 برنامج تدريبي",
          }
        },
        {
          year: "2006",
          desc: {
            en: "Expanded to Egypt",
            ar: "التوسع إلى مصر",
          }
        },
        {
          year: "2011",
          desc: {
            en: "Renamed to Al-Saeed Academy",
            ar: "تغيير الاسم إلى أكاديمية السعيد",
          }
        }
      ]
    },
  };

  return (
    <section id="about" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4">
            {language === "ar" ? "حول الاكاديمية" : "About the Academy"}
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto"></div>
        </div>

        {/* Mission & Vision */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-green-50 p-8 rounded-2xl border-l-4 border-green-600 transform hover:-translate-y-1 transition-all duration-300">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 rtl:mr-0 rtl:ml-4">
                <svg
                  className="w-6 h-6 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-green-900">
                {aboutData.vision.title[language]}
              </h3>
            </div>
            <p className="text-gray-700 leading-relaxed">
              {aboutData.vision.content[language]}
            </p>
          </div>
          
          <div className="bg-green-50 p-8 rounded-2xl border-l-4 border-green-600 transform hover:-translate-y-1 transition-all duration-300">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 rtl:mr-0 rtl:ml-4">
                <svg
                  className="w-6 h-6 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-green-900">
                {aboutData.mission.title[language]}
              </h3>
            </div>
            <p className="text-gray-700 leading-relaxed">
              {aboutData.mission.content[language]}
            </p>
          </div>
        </div>

        {/* Goals */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold text-green-900 mb-6 text-center">
            {aboutData.goals.title[language]}
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            {aboutData.goals.items.map((goal, index) => (
              <div
                key={index}
                className="flex items-start p-4 bg-white rounded-lg shadow-sm border border-green-100 hover:shadow-md transition-shadow"
              >
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-800 rounded-full flex items-center justify-center font-bold mr-4 rtl:mr-0 rtl:ml-4 mt-1">
                  {index + 1}
                </div>
                <p className="text-gray-700">{goal[language]}</p>
              </div>
            ))}
          </div>
        </div>

        {/* History Summary */}
        <div className="bg-gradient-to-r from-green-800 to-green-900 text-white p-8 rounded-2xl mb-8">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6">
            <div>
              <h3 className="text-2xl font-bold mb-2">
                {aboutData.history.title[language]}
              </h3>
              <p className="text-green-200 max-w-2xl">
                {aboutData.history.content[language]}
              </p>
            </div>
            <Link 
              to="/about" 
              className="mt-4 md:mt-0 inline-flex items-center px-6 py-3 bg-white text-green-800 font-bold rounded-lg hover:bg-green-50 transition-colors shadow-lg hover:shadow-xl"
            >
              <span>{language === "ar" ? "عرض التاريخ الكامل" : "View Full History"}</span>
              <svg className="w-5 h-5 ml-2 rtl:ml-0 rtl:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </Link>
          </div>

          {/* Timeline highlights */}
          <div className="mt-8 grid md:grid-cols-4 gap-6">
            {aboutData.history.highlights.map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-3 font-bold text-lg">
                  {item.year}
                </div>
                <p className="text-green-200">{item.desc[language]}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <Link 
            to="/about" 
            className="inline-flex items-center px-8 py-4 bg-green-600 text-white font-bold text-lg rounded-xl hover:bg-green-700 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-1 duration-300"
          >
            <span>{language === "ar" ? "اكتشف المزيد عن تاريخنا" : "Discover More About Our History"}</span>
            <svg className="w-6 h-6 ml-3 rtl:ml-0 rtl:mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default About;